//
// Imports
//

import * as FritterApiUtilities from "@donutteam/fritter-api-utilities";
import { z } from "zod";

//
// Types
//

export type RequestBody = z.infer<typeof RequestBodySchema>;

export const RequestBodySchema = z.object(
	{
		websiteUrls: z.array(z.string().trim().url()).max(5),
	});

export type ResponseBody = z.infer<typeof ResponseBodySchema>;

export const ResponseBodySchema = z.union(
	[
		FritterApiUtilities.SuccessResponseBodySchema.extend(
			{
				websites: z.array(z.object(
					{
						id: z.number(),
						url: z.string(),
					})),
			}),

		FritterApiUtilities.ErrorResponseBodySchema,
	]);